import { useRouter } from "next/router";
import React, { useEffect } from "react";
import useLoginStatus, { LoginStatus } from "@lib/hooks/useLoginStatus";
import { useGetOwnCompaniesQuery } from "@lib/store/slices/companies";
import LoadingOverlayWithHint from "./LoadingOverlayWithHint";

/**
 * Authenticated Route: Only let logged in users see this page.
 */
function AuthenticatedRoute({
  children,
  withoutOnboarding,
}: {
  children: React.ReactNode;
  withoutOnboarding?: boolean;
}) {
  const router = useRouter();
  const loginStatus = useLoginStatus();
  const { data: companies, isLoading: isLoadingCompanies } =
    useGetOwnCompaniesQuery();

  useEffect(() => {
    if (loginStatus === LoginStatus.LoggedOut) {
      router.push({
        pathname: "/account/auth/login",
        query: { returnUrl: router.asPath },
      });
    }

    if (
      loginStatus === LoginStatus.LoggedIn &&
      !companies?.length &&
      !isLoadingCompanies &&
      !withoutOnboarding
    ) {
      router.push("/account/onboarding");
    }
    if (
      loginStatus === LoginStatus.LoggedIn &&
      (companies?.length || 0) > 0 &&
      !isLoadingCompanies &&
      withoutOnboarding
    ) {
      router.push("/account/jobs");
    }
  }, [loginStatus, companies, isLoadingCompanies, router, withoutOnboarding]);

  if (loginStatus === LoginStatus.LoggedIn && !isLoadingCompanies) {
    return <>{children}</>;
  }
  return (
    <LoadingOverlayWithHint visible hint="Lade Profil..." overlayOpacity={1} />
  );
}

export default AuthenticatedRoute;
